<template>
  <div class="wizard-nav">
    <v-btn
      v-if="!isFirstStep"
      text
      color="grey darken-1"
      class="text-none"
      :disabled="loading"
      @click="$emit('back')"
    >
      ← Back
    </v-btn>
    <div class="wizard-nav__spacer" />
    <v-btn
      v-if="canSkip"
      text
      color="grey"
      class="text-none mr-2"
      :disabled="loading"
      @click="$emit('skip')"
    >
      Skip
    </v-btn>
    <v-btn
      color="primary"
      depressed
      dark
      class="text-none"
      :disabled="!canAdvance"
      :loading="isLastStep && loading"
      @click="$emit('next')"
    >
      {{ nextLabel }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'WizardNav',
  props: {
    isFirstStep:  { type: Boolean, default: false },
    isLastStep:   { type: Boolean, default: false },
    canAdvance:   { type: Boolean, default: true },
    canSkip:      { type: Boolean, default: false },
    submitLabel:  { type: String,  default: 'Create my garden' },
    loading:      { type: Boolean, default: false },
  },
  computed: {
    nextLabel() {
      if (this.isFirstStep) return "Let's go →"
      if (this.isLastStep)  return this.submitLabel
      return 'Next →'
    },
  },
}
</script>

<style scoped>
.wizard-nav {
  display: flex;
  align-items: center;
  margin-top: 28px;
}
.wizard-nav__spacer {
  flex: 1;
}
</style>
